import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

/**
 * Effect-based redirect (not beforeLoad / <Navigate>) so a navigation to
 * `$groupId` briefly settles on that URL — matching the old RR `<Redirect>`
 * hop that create-flow tests observe before the members redirect completes.
 */
const UserGroupIndexRedirect = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const { groupId } = Route.useParams();

  useEffect(() => {
    navigate({
      to: '/administration/user-groups/$groupId/members/$page/$limit',
      params: { groupId, page: '1', limit: '10' },
      replace: true,
    });
  }, [groupId, navigate]);

  return null;
};

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId/')({
  component: UserGroupIndexRedirect,
});
